import CrmModal from './CrmModel'

var Crm = new CrmModal()
export default Crm



// WEBPACK FOOTER //
// ./src/api/Crm.js